import {endOfDay, parseISO, startOfDay} from "date-fns";
import {type Invoice, isPlanInvoice} from "../types/invoice";

/** Whether an instant falls on or between two calendar days (`yyyy-MM-dd`), both inclusive; empty bounds are open. */
export function createdWithinDays(createdAt: string, fromDay: string, toDay: string): boolean {
    const created = parseISO(createdAt).getTime();
    if (fromDay && created < startOfDay(parseISO(fromDay)).getTime()) return false;
    if (toDay && created > endOfDay(parseISO(toDay)).getTime()) return false;
    return true;
}

/** The amount the invoice charges: a plan invoice's proration credit is shown as a deduction from its total. */
export function invoiceTotalInCents(invoice: Invoice): number {
    const total = (invoice.orderDetails as {totalPriceInCents?: number}).totalPriceInCents ?? 0;
    return isPlanInvoice(invoice) ? total - (invoice.prorationCreditInCents ?? 0) : total;
}
